module.exports = __webpack_public_path__ + "img/mastercard.df220b02.svg";